import { Card, Col, Form } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BasicFloatingInputControls } from "../../../../Constant";
import { FLOATING_INPUT } from "../../../../Data/FormControl/BaseInput";
import { BasicFloatingFooter } from "./BasicFloatingFooter";
import { BasicFloatingCardBody } from "./BasicFloatingCardBody";

const BasicFloatingInputControl = () => {
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={BasicFloatingInputControls} span={FLOATING_INPUT} />
        <Form className="theme-form" onSubmit={(e)=>e.preventDefault()}>
          <BasicFloatingCardBody/>
          <BasicFloatingFooter />
        </Form>
      </Card>
    </Col>
  );
};

export default BasicFloatingInputControl;
